module.exports = __webpack_public_path__ + "static/media/produce_01.db6fe118.png";